import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LayoutComponent } from './layouts/layout.component';

// Auth 
import { AuthGuard } from './core/auth/guards/auth.guard';
import { InitialDataResolver } from './app.resolvers';
import { NoAuthGuard } from './core/auth/guards/noAuth.guard';
import { TermsAndConditionsComponent } from './extraspages/terms-and-conditions/terms-and-conditions.component';
import { PrivacyPolicyComponent } from './extraspages/privacy-policy/privacy-policy.component';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule),
    canActivate: [AuthGuard],
    resolve: {
      initialData: InitialDataResolver,
    },
  },
  {
    path: 'terms-and-conditions',
    component: TermsAndConditionsComponent,
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent,
  },
  {
    canActivate: [NoAuthGuard],
    canActivateChild: [NoAuthGuard],
    path: 'auth',
    loadChildren: () => import('./account/account.module').then(m => m.AccountModule)
  },
  {
    path: 'extraspages',
    canActivate: [AuthGuard],
    component: LayoutComponent,
    resolve: {
      initialData: InitialDataResolver,
    },
    loadChildren: () => import('./extraspages/extraspages.module').then(m => m.ExtraspagesModule)
  },
  { path: '**', redirectTo: 'extraspages' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
